import React, { useMemo } from 'react';
import EditComponent from '../../utils/EditComponent';
import ModuleConfigPlaceholder from '../ModuleConfigPlaceholder/ModuleConfigPlaceholder';
import classPriority from '../../utils/classPriority';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';

export const mapComponents = (
  componentsArray: {
    Component: React.LazyExoticComponent<React.ComponentType<any>>;
    ComponentName: any;
  }[],
  modulesConfigs: any,
  theme: any,
  pageId: string,
  pagePath: string,
  pageComponents: string[],
  setComponents: React.Dispatch<React.SetStateAction<any>>,
  selectedInstance: string | null,
  setSelectedInstance: React.Dispatch<React.SetStateAction<string | null>>,
  generateCssVariables: (selector: string, theme: any) => void,
  isDynamicPage?: boolean,
  page?: any,
  promotionRes?: any
) => {
  const { searchParams: reduxSearchParams } = useSelector(
      (state: RootState) => state.search
  );
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  if (!componentsArray?.length) {
    return <ModuleConfigPlaceholder />;
  }

  return componentsArray.map((component, i) => {
    const { Component, ComponentName } = component;
    const instance = ComponentName;
    const moduleName = modulesConfigs[ComponentName]?.module ?? ComponentName;
    const componentModuleConfig =
      modulesConfigs[instance] || modulesConfigs[moduleName];
      // if(page.type == "searchResultPage" && moduleName != "SwitchDatePicker" && !checkSearchPageFirstLoaded(reduxSearchParams,searchParams)){
      //   return ;
      // }
    return (
      <EditComponent
        pageId={pageId}
        pagePath={pagePath}
        pageComponents={pageComponents}
        instance={instance}
        moduleName={moduleName}
        key={`${i}_${instance}`}
        index={String(i)}
        setComponents={setComponents}
        selectedInstance={selectedInstance}
        setSelectedInstance={setSelectedInstance}
        isEditAllowed={modulesConfigs[ComponentName]?.allow_edit !== false}
        isDynamicPage = {isDynamicPage}
      >
        <div className={ComponentName}>
          {componentModuleConfig?.theme &&
            generateCssVariables(
              `.${ComponentName}`,
              componentModuleConfig.theme as any
            )}
          <Component
            config={{
              ...componentModuleConfig,
              instance,
              page,
              promotionRes
            }}
            componentStyle={classPriority(theme, componentModuleConfig)}
          />
        </div>
      </EditComponent>
    );
  });
};
const checkSearchPageFirstLoaded = (reduxSearchParams: any, searchParams: URLSearchParams): boolean => {
  const noReduxDestination = !reduxSearchParams.destination && !reduxSearchParams.destinationCity;
  const noSearchParams = !searchParams?.toString() || searchParams?.toString() == "editMode=true"

  return  noSearchParams;
}